export const informationsContent = {
    title: {
        site: 'Vos informations',
        conseiller: 'Informations du client',
        conseillermae: "Informations de l'adhérent",
    },
    allFamilly: {
        site: '<b>A SAVOIR</b> : Si plusieurs membres de votre foyer utilisent le véhicule (conjoint ou enfants de plus de 14 ans), ils sont assurés au même titre que le souscripteur.',
        conseiller:
            '<b>A SAVOIR</b> : Si plusieurs membres du foyer de votre client utilisent le véhicule (conjoint ou enfants de plus de 14 ans), ils sont assurés au même titre que le souscripteur.',
        conseillermae:
            '<b>A SAVOIR</b> : Si plusieurs membres du foyer de votre adhérent utilisent le véhicule (conjoint ou enfants de plus de 14 ans), ils sont assurés au même titre que le souscripteur.',
    },
    codeVendeurMAEInfo: {
        site: 'Le devis va être validé après cette étape. Un email va partir avec les documents contractuels.',
        conseiller: 'Le devis va être validé après cette étape. Un email va partir au client avec les documents contractuels.',
        conseillermae: "Le devis va être validé après cette étape. Un email va partir à l'adhérent avec les documents contractuels.",
    },
    civiliteLabel: {
        site: 'Civilité',
    },
    nomLabel: {
        site: 'Nom de famille',
    },
    nomPlaceholder: {
        site: 'Votre nom de famille',
        conseiller: 'Nom de famille du client',
        conseillermae: "Nom de famille de l'adhérent",
    },
    nomNaissanceLabel: {
        site: 'Nom de naissance',
    },
    nomNaissancePlaceholder: {
        site: 'Votre nom de naissance',
        conseiller: 'Nom de naissance du client',
        conseillermae: "Nom de naissance de l'adhérent",
    },
    prenomLabel: {
        site: 'Prénom',
    },
    prenomPlaceholder: {
        site: 'Votre prénom',
        conseiller: 'Prénom du client',
        conseillermae: "Prénom de l'adhérent",
    },
    dateNaissanceLabel: {
        site: 'Date de naissance',
    },
    nombrePersonnesLabel: {
        site: 'Nombre de personnes dans le foyer',
    },
    bulleAide: {
        site: 'Nombre de personnes vivant de façon permanente au domicile assuré (y compris vous-même).',
        conseiller: 'Nombre de personnes vivant de façon permanente au domicile assuré (y compris le client).',
        conseillermae: "Nombre de personnes vivant de façon permanente au domicile assuré (y compris l'adhérent).",
    },
    attestationLabel: {
        site: "J'atteste sur l'honneur l'exactitude des déclarations ci-dessus",
    },
    rgpdTitle: {
        site: 'Vos données personnelles',
    },
    rgpdDescription: {
        site: "Les données personnelles que vous renseignez dans ce formulaire sont nécessaires pour établir une proposition, pour la conclusion et l'exécution du contrat d'assurance deux roues et la prise en charge des garanties qui y sont associées. Ces informations ne sont pas transmises à des fins publicitaires. Vous pourrez demander à tout moment à accéder, modifier, rectifier ou supprimer ces données vous concernant.",
    },
    rgpdExpandedContent: {
        site: `<p>Les données traitées font l'objet d'un traitement automatisé y compris le profilage, donnant lieu à l'établissement d'un tarif adapté à votre situation. Vos données peuvent être utilisées à des fins statistiques en vue d'alimenter et d'affiner notre outil de tarification, y compris dans le cas où vous ne donnez pas suite à votre proposition.</p>
<p>En collectant vos données de proposition APRIL Moto est susceptible de vous adresser des relances par mail afin de finaliser votre contrat. A cet effet, APRIL Moto s'engage à prendre toutes les mesures de sécurité nécessaires afin de préserver la confidentialité de vos données en respectant les dispositions du Règlement Général sur la Protection des Données à Caractère Personnel.</p>
<p>Dans le cadre du Règlement Général sur la Protection des Données à Caractère Personnel, vous pouvez à tout moment faire valoir vos droits en contactant l'adresse suivante : <a href="mailto:dpo@april-moto.com" class="text-primary hover:underline">dpo@april-moto.com</a></p>
<p>Pour plus d'informations sur les traitements dont font l'objet vos données personnelles, vous pouvez à tout moment consulter notre politique de confidentialité sur notre site internet <a href="https://www.april-moto.com" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">https://www.april-moto.com</a></p>`,
    },
} as const;
